import React from "react";
import ReusableModal from "components/Modals/ReusableModal";

const DeleteResourceModal = ({ isOpen, onClose, onConfirm }) => {
  return (
    <ReusableModal
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={onConfirm}
      title="Delete Resource"
      bodyMessage="Are you sure you want to delete this resource?"
    />
  );
};

export default DeleteResourceModal;